import { ReactNode } from 'react';
import { cn } from '../../lib/cn';

interface Props {
  label: string;
  value: ReactNode;
  suffix?: string;
  accent?: 'default' | 'usdt' | 'cp' | 'rp' | 'success';
  className?: string;
}

const tones: Record<NonNullable<Props['accent']>, string> = {
  default: 'text-fg',
  usdt:    'text-accent',
  cp:      'text-fg',
  rp:      'text-[rgb(255_107_112)]',
  success: 'text-success',
};

export function StatCard({ label, value, suffix, accent = 'default', className }: Props) {
  return (
    <div className={cn('bg-surface-2 border border-border rounded-xl p-3.5', className)}>
      <div className="text-[10px] font-semibold tracking-wider uppercase text-fg-muted">{label}</div>
      <div className={cn('mt-1 text-xl font-bold font-mono', tones[accent])}>
        {value}
        {suffix && <span className="ml-1 text-sm text-fg-muted font-sans font-medium">{suffix}</span>}
      </div>
    </div>
  );
}
